export const REPORTS_GET_DRIVER_ANALYTICS = `
  query DriverGetDriverAnalytics($req: GetDriverAnalyticsRequestInput) {
    driverGetDriverAnalytics(req: $req) {
      responseCode
      responseMessage
      data {
        id
        taskCount
        driverCode
        driverName
        driverMobile
      }
    }
  }
`;

export const REPORTS_GET_DRIVER_REPORT = `
  query TaskGetDriverReport($req: GetDriverAnalyticsV2RequestInput) {
    taskGetDriverReport(req: $req) {
      responseCode
      responseMessage
      data {
        pk_task_id
        order_id
        task_description
        estimated_time
        distance
        delivery_date
        waiting_time
        task_update
        charges
        foodIsReadytoSuccessful
        pickeduptoSuccessful
        actual_estimated_time
        foodIsReadytoPickedup
        arrival_time
        acknowledged_time
        food_ready_time
        driver_food_ready_time
        picked_up_time
        delivery_time
        acknowledgetosuccessful
        driverfoodisreadytosuccessful
      }
    }
  }
`;

export const REPORTS_GET_TASK_ANALYTICS = `
  query TaskGetTaskAnalytics($req: GetTaskAnalyticsRequestInput) {
    taskGetTaskAnalytics(req: $req) {
      responseCode
      responseMessage
      data {
        id
        taskCount
        shopCode
        shopName
      }
    }
  }
`;

export const REPORTS_GET_TASK_ANALYTICS_BY_STATUS = `
  query TaskGetTaskAnalyticsByStatus($req: GetTaskAnalyticsByStatusRequestInput) {
    taskGetTaskAnalyticsByStatus(req: $req) {
      responseCode
      responseMessage
      data {
        id
        taskCount
        taskStatus
      }
    }
  }
`;